<template>
  <FlexLayout id="mealPlanReservation" role="region">
    <vue-loading :active="isLoading" :is-full-page="true" />

    <BlockContainer v-if="reservation" :title="$t('mealPlan.subTitle.reservation')">
      <OrderDetails
        :guid="reservation.guid"
        :shop-id="reservation.shopId"
        @cancelOrder="onCancelOrder"
      />
    </BlockContainer>
  </FlexLayout>
</template>

<script>
import Utils from "../../../utils/utils";
import VueLoading from "vue-loading-overlay";
import {useShopStore} from "../../../stores/shop";
import productDetailsMixin from "@/components/mixins/productDetailsMixin";
import {cleanedProdOptionText} from "../../../utils/productUtils";
import orderMixin from "@/components/mixins/orderMixin";
import {normalizeStatusString} from "@/utils/stringUtils";
import BlockContainer from "@/components/layout/BlockContainer.vue";
import FlexLayout from "@/components/layout-components/Main/FlexLayout.vue";
import OrderDetails from "@/components/sub-components/Order/OrderDetails.vue";

export default {
  mixins: [productDetailsMixin, orderMixin],
  computed: {
    config() {
      return window.config
    },
    utils() {
      return Utils
    },
  },
  components: {
    OrderDetails,
    FlexLayout,
    BlockContainer,
    VueLoading,
  },
  data() {
    return {
      isLoading: false,
      selectedProduct: null,
    }
  },
  props: {
    reservation: {
      type: Object,
      required: true
    },
    showVat: {
      type: Boolean,
      default: true
    }
  },
  setup() {
    const shopStore = useShopStore();

    return {
      shopStore
    };
  },
  methods: {
    normalizeStatusString,
    cleanedProdOptionText,
    onViewProductDetails(product) {
      this.selectedProduct = product;
      this.$bvModal.show("product-details-modal");
    },
    async onCancelOrder(guid) {
      this.isLoading = true;
      const success = await this.cancelOrder(this.shopStore, guid);
      if (success) {
        this.$emit('reservation-canceled');
      }
      this.isLoading = false;
    },
  }
};
</script>

<style scoped lang="scss">
@import "@/css/customizer";


.meal-container {
  margin-top: 10px
}

.meal-group {
  text-align: left;
  margin: 0 auto;
  padding: 0 10px;
}

.meal-group-title {
  font-size: 20px;
  display: flex;
  justify-content: space-between; /* Space between the two spans */
  align-items: center; /* Center the text vertically */
  width: 100%; /* Ensure it takes the full width */
}

.meal-item {
  display: flex;
  flex: 1 0 360px;
  gap: 10px;
  text-align: left;
  align-items: stretch;
  padding: 10px;
  transition: background-color 0.3s ease, transform 0.3s ease; /* Smooth transition effect */
  height: 100%;
}

.meal-item:hover {
  background-color: #e0e0e0; /* Change background on hover */
  transform: scale(1.02); /* Slightly scale up the item */
  cursor: pointer; /* Add pointer cursor */
}

.meal-image {
  width: 120px;
  height: auto;
  margin-right: unset;
  border: custom-chain(mealplan-productimage-border,'');
  object-fit: cover;
}

.meal-details {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.meal-description {
  font-weight: bold;
  text-align: left;
}

.properties {
  filter: hue-rotate(45deg);
}

.allergens, .properties {
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  margin-top: 5px;
}

.allergen-img,
.property-img {
  max-width: 30px;
}

.meal-price {
  color: indianred;
  font-size: 14px;
  align-self: center;
  flex-grow: 1;
  text-align: right;
}

.button {
  display: flex;
  align-items: center;
  padding: 10px 15px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  user-select: none; /* Prevent text selection */
  transition: background-color 0.3s; /* Smooth background change */
}

.button:hover,
.button:focus {
  background-color: #0056b3; /* Darker blue on hover/focus */
}

.button:active {
  background-color: #004494; /* Even darker on click */
}

.meal-item-total {
  font-weight: bold;
  color: custom-chain(mealplan-reservation-item-total,darkgreen);
  margin-left: auto;
}

.meal-quantity {
  font-size: 14px;
  color: custom-chain(mealplan-reservation-item-quantity,#555);
  margin-right: 10px;
}

#order-total {
  font-weight: bold;
  font-size: 18px;
  padding: 10px;
}

.total-amount {
  color: custom-chain(mealplan-reservation-total,darkred);
  font-size: 18px;
}

.basket-total {
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  padding: 12px 0;
  border-top: 1px solid #ccc;
  margin-top: 12px;
}

.basket-total.no-vat {
  border-top: none;
  margin-top: 0;
}

.total-price {
  color: #0057b8;
}

.basket-payments, .basket-vats {
  margin-top: 10px;
  padding: 10px;
  border-top: 1px solid #ddd;
}

.payment-row, .vat-row {
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
}

.cancel-order-button {
    background-color: red;
    color: white;
    border: none;
    padding: 10px 20px;
    cursor: pointer;
}
</style>
